import Vue from 'vue'
import Meta from 'vue-meta'
import VueBrowserUpdate from 'vue-browserupdate'
import PMDApp from './pmd/PMDApp.vue'
import router from './routes'
import store from './store'
import firebase from 'firebase/compat/app'
import 'firebase/compat/auth'
import 'firebase/compat/firestore'
import 'firebase/compat/performance'
import 'firebase/compat/messaging'
import 'firebase/compat/storage'
import { getRemoteConfig,fetchAndActivate } from "firebase/remote-config";
import config from './config'
import axios, { AxiosRequestConfig } from 'axios'
import VeeValidate, { Validator } from 'vee-validate'
import { email } from 'vee-validate/dist/rules.esm'
import { AuthUser, User, Company } from './models'
import Vue2Filters from 'vue2-filters'
import VueHighcharts from 'vue-highcharts'
import Highcharts from 'highcharts'
import Maps from 'highcharts/modules/map'
import loadHighchartsMore from 'highcharts/highcharts-more'
import loadSolidGauge from 'highcharts/modules/solid-gauge'
import NoDataModule from 'highcharts/modules/no-data-to-display.js'
import libphonenumber from 'google-libphonenumber'
import NotificationHelper from './util/notification_helper'
import UxMessagePlugin from './plugins/UxMessagePlugin'
import infiniteScroll from 'vue-infinite-scroll'
import VueCookie from 'vue-cookie'
// import NodeTree from './pmd/components/workflow/NodeTree'
import LoaderSlot from './pmd/components/LoaderSlot'
import MoonLoader from './pmd/components/MoonLoader'
import MoonLoaderTitle from './pmd/components/MoonLoaderTitle'
import draggable from 'vuedraggable'
import { VueMasonryPlugin } from 'vue-masonry'
import '@/mixins/globalmixin'
import {  trim } from 'lodash'
import JSSoup from 'jssoup'
import localStorage from 'store'
import VueExpandableImage from 'vue-expandable-image'
import { OauthService } from '@/services'
import LogsService from '@/services/LogsService'
import VTooltip from 'v-tooltip'

// Global vue event bus to transmit/listen event globally
Vue.prototype.$bus = new Vue()
// Using Vtooltip to render raw html content. Not possible with current tootltip lib
Vue.use(VTooltip)
Vue.component('loader-slot', LoaderSlot)
Vue.component('moon-loader', MoonLoader)
Vue.component('moon-loader-title', MoonLoaderTitle)
Vue.component('draggable', draggable)
import './plugins/setupEmitter'
// array helper
require('./util/array_helper')

import BootstrapVue from 'bootstrap-vue'

Vue.use(BootstrapVue)
Vue.use(VueExpandableImage)
Vue.use(VueCookie)

Maps(Highcharts)

// tailwindcss

import "./assets/pmd/css/tailwind.css"
import {registerComponents} from './pmd/components/UIComponents'
Vue.use(registerComponents)
// Vue composition API for vue 2
import VueCompositionAPI from '@vue/composition-api'
Vue.use(VueCompositionAPI)

import VueFinalModal from 'vue-final-modal'

Vue.use(VueFinalModal())

import Notifications from 'vue-notification'
import velocity from 'velocity-animate'

Vue.use(Notifications, { velocity })

Highcharts.theme = {
  colors: [
    '#0266C8',
    '#ff7a59',
    '#F2B50F',
    '#f28f43',
    '#77a1e5',
    '#c42525',
    '#a6c96a',
  ],
  chart: {
    style: {
      fontFamily: 'Roboto',
      color: '#444444',
    },
  },
  xAxis: {
    gridLineWidth: 1,
    gridLineColor: '#F3F3F3',
    lineColor: '#F3F3F3',
    minorGridLineColor: '#F3F3F3',
    tickColor: '#F3F3F3',
    tickWidth: 1,
  },
  yAxis: {
    gridLineColor: '#F3F3F3',
    lineColor: '#F3F3F3',
    minorGridLineColor: '#F3F3F3',
    tickColor: '#F3F3F3',
    tickWidth: 1,
  },
  legendBackgroundColor: 'rgba(0, 0, 0, 0.5)',
  background2: '#505053',
  dataLabelsColor: '#B0B0B3',
  textColor: '#C0C0C0',
  contrastTextColor: '#F0F0F3',
  maskColor: 'rgba(255,255,255,0.3)',
  lang: {
    thousandsSep: ',',
  },
}
// Apply the theme
Highcharts.setOptions(Highcharts.theme)
loadHighchartsMore(Highcharts)
loadSolidGauge(Highcharts)
NoDataModule(Highcharts)
Vue.use(VueHighcharts, { Highcharts })

Vue.use(infiniteScroll)
Vue.config.devtools = process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'staging'

Vue.config.productionTip = process.env.NODE_ENV === 'development'

Vue.config.ignoredElements = ['chat-widget']
Vue.use(Meta)
Vue.use(VueBrowserUpdate, {
  options: {},
})
Vue.use(Vue2Filters)

Vue.use(UxMessagePlugin, {
  rootSelector: '#app',
})

Vue.use(VueMasonryPlugin)

const firebaseApp = firebase.initializeApp(config.firebase)

// const firestore = firebase.firestore()
// firestore.settings({})
setupAuth()
// if (config.mode !== 'production') {
//   firebase.firestore.setLogLevel('debug');
// }

// firebase
//   .firestore()
//   .enablePersistence()
//   .catch(function(err) {
//     console.error('Firebase persistence error:', err)
//     if (err.code == 'failed-precondition') {
//       console.warn(
//         'Multiple tabs open, persistence can only be enabled in one tab at a a time.'
//       )
//       //
//       //
//     } else if (err.code == 'unimplemented') {
//       console.warn(
//         'The current browser does not support all of the features required to enable persistence'
//       )
//     }
//   })

Vue.prototype.$auth = firebase.auth()

if ('serviceWorker' in navigator) {
  if (config.mode === 'dev' || config.mode === 'staging') {
    navigator.serviceWorker
      .register('/pmd-fcm-sw-staging.js')
      .then(registration => {
        NotificationHelper.init(registration)
      })
  } else {
    navigator.serviceWorker.register('/pmd-fcm-sw.js').then(registration => {
      NotificationHelper.init(registration)
    })
  }
}

if (localStorage.get('proxyLoginCount') === undefined) {
  localStorage.set('proxyLoginCount', 0)
}
window.addEventListener('storage', async (e) => {
  if (e.key === 'proxyLoginCount') {
    try {
      if (localStorage.get('proxyLoginCount') == 0) return
      if (localStorage.get('proxyLoginCount') == undefined) {
        console.log('user logged out on other tab')
        await router.push({ name: 'login', params: { logout: 'true' } })
        await store.dispatch('logout')
        return
      }
      if (!localStorage.get('a')) return
      const authState = await store.dispatch('auth/get')
      const authLocalStorage = JSON.parse(atob(localStorage.get('a')))
      console.log(authState, authLocalStorage)
      if (authState?.userId && authLocalStorage?.userId && authState?.userId !== authLocalStorage?.userId) {
        console.log('Reloading page as userID different in state and storage, Changed in other tabs')
        window.location.reload()
        return
      }
    } catch (error) {
      console.error('Error while state and localstorage user check',error)
    }
  }
});

window.addEventListener('unhandledrejection',async function(event) {
    if (event?.reason?.message === 'Missing or insufficient permissions.') {
      let authState, authLocalStorage, firebaseToken, userState, role, type, locationCount

      try {
        authState = await store.dispatch('auth/get')
        authLocalStorage = JSON.parse(atob(localStorage.get('a')))
        console.log('authState', authState, authLocalStorage)
        if (authState?.userId && authLocalStorage?.userId && authState?.userId !== authLocalStorage?.userId) {
          console.log('Reloading page as userID different in state and storage')
          window.location.reload()
          return
        }
      } catch (error) {
        console.error('Error while state and localstorage user check',error)
      }

      console.log('Logging out on Global Permissions error handler.')

      try {
        try {
          firebaseToken = await firebase?.auth()?.currentUser?.getIdToken()
          userState = await store.dispatch('user/get')
          role = userState?.role
          type = userState?.type
          locationCount = Object.keys(userState?.locations)?.length
        } catch(err) {}
        await LogsService.dump('frontend-logout', { instance: 'Global Permissions error handler', event, page: window?.location?.href, authState, authLocalStorage, firebaseToken, role, type, locationCount })
      } catch(err) {}

      try {
        router.push({ name: 'login', params: { logout: 'true' } })
        await store.dispatch('logout')
        try {
          firebase.auth().signOut()
        } catch (err) {
          console.error(
            'Error while logging out on Global Permissions error handler - firebase auth.',
            err
          )
        }
        try {
          await store.dispatch('auth/signOutFromBackend')
        } catch (err) {
          console.error(
            'Error while logging out on Global Permissions error handler - axios signout.',
            err
          )
        }

        // Clear all the cookies and localostorage
        document.cookie.split(';').forEach(function (c) {
          document.cookie = c
            .replace(/^ +/, '')
            .replace(/=.*/, '=;expires=' + new Date().toUTCString() + ';path=/')
        })
        window.localStorage.clear()

        // Clear the Indexed DB
        if (window.indexedDB) {
          const dbs = [
            'firebase-installations-database',
            'firebaseLocalStorageDb',
            'firebase-messaging-database',
          ]
          dbs.forEach(db => {
            window.indexedDB.deleteDatabase(db)
          })
        }

      } catch (err) {
        console.error(
          'Error while logging out on Global Permissions error handler.',
          err
        )
      }
    }
  }
)


firebase.auth().onAuthStateChanged(async user => {
  try {
    if (user) {
      const auth = await store.dispatch('auth/get')
      if (auth && auth.userId && !auth.jwt) {
       console.log('JWT not exist')
       const authWithJwt = await OauthService.getCurrentUser()
       if (!authWithJwt?.jwt || !authWithJwt?.refreshJwt) {
          throw new Error("Not able to get JWT tokens for the User");
       }
       const authSetData = {
          firebaseToken: authWithJwt.firebaseToken,
          jwt: authWithJwt.jwt,
          refreshJwt: authWithJwt.refreshJwt,
          apiKey: authWithJwt.apiKey,
          userId: authWithJwt.userId,
          companyId: authWithJwt.companyId,
          authToken: authWithJwt.authToken,
          refreshToken: authWithJwt.refreshToken
      };
       await store.dispatch('auth/set', authSetData);
      }
    }
  } catch (error) {
    console.warn('Error while setting tokens', error)
  }
})

const VueCtkDateTimePicker = () =>
  import(/* webpackChunkName: "lib-datepicker" */ 'vue-ctk-date-time-picker')
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'
import { getDecodedJWT } from './util/jwt_helper'
import { setupAuth } from './util/setup_auth'

Vue.component('vue-ctk-date-time-picker', VueCtkDateTimePicker)

Vue.prototype.$private = {}


const remoteConfig = getRemoteConfig(firebaseApp);
remoteConfig.settings.minimumFetchIntervalMillis = 3600000
remoteConfig.settings.fetchTimeoutMillis = 60000
fetchAndActivate(remoteConfig).then(() => {
  console.log('app init')
})
.catch((err) => {
  console.error('remote config failed')
});

Vue.prototype.remoteConfig = remoteConfig

axios.defaults.baseURL = config.baseUrl
axios.interceptors.request.use(async (requestConfig: AxiosRequestConfig) => {
  try {
    const auth: AuthUser = new AuthUser(await store.dispatch('auth/get'))
    requestConfig.headers.authorization = 'Bearer ' + auth.apiKey
    if (!requestConfig.url.includes('algolia')) {
      requestConfig.headers['token-id'] = await firebase
        .auth()
        .currentUser.getIdToken()
    }
    // tslint:disable-next-line:no-empty
  } catch (e) {}
  return requestConfig
})
Vue.prototype.$http = axios

const pythonBackend = axios.create({
  baseURL: config.pythonBaseUrl,
})
pythonBackend.interceptors.request.use(
  async (requestConfig: AxiosRequestConfig) => {
    try {
      const auth: AuthUser = new AuthUser(await store.dispatch('auth/get'))
      requestConfig.headers.authorization = 'Bearer ' + auth.apiKey
      // tslint:disable-next-line:no-empty
    } catch (e) {}
    return requestConfig
  }
)
Vue.prototype.pythonBackend = pythonBackend

const membershipBackend = axios.create({
  baseURL: config.membershipUrl,
})
membershipBackend.interceptors.request.use(
  async (requestConfig: AxiosRequestConfig) => {
    try {
      requestConfig.headers.authorization =
        'Bearer ' + (await firebase.auth().currentUser.getIdToken())
      // tslint:disable-next-line:no-empty
    } catch (e) {}
    return requestConfig
  }
)
Vue.prototype.membershipBackend = membershipBackend


const snapshotBackend = axios.create({
  baseURL: config.snapshotServiceUrl,
})
snapshotBackend.interceptors.request.use(
  async (requestConfig: AxiosRequestConfig) => {
    try {
      const auth: AuthUser = new AuthUser(await store.dispatch('auth/get'))
      requestConfig.headers.authorization = 'Bearer ' + auth.apiKey
      if (!requestConfig.url.includes('algolia')) {
        requestConfig.headers[
          'token-id'
        ] = await firebase.auth().currentUser.getIdToken()
      }
    } catch (e) {}
    return requestConfig
  }
)
Vue.prototype.$snapshotBackend = snapshotBackend

const dialogflowEngagements = axios.create({
  baseURL: config.dialogflowEngagementsBaseUrl,
})
dialogflowEngagements.interceptors.request.use(
  async (requestConfig: AxiosRequestConfig) => {
    try {
      const auth: AuthUser = new AuthUser(await store.dispatch('auth/get'))
      requestConfig.headers.authorization = 'Bearer ' + auth.apiKey
      // tslint:disable-next-line:no-empty
    } catch (e) {}
    return requestConfig
  }
)
Vue.prototype.dialogflowEngagements = dialogflowEngagements

const paymentService = axios.create({
  baseURL: config.paymentServiceBaseUrl,
})
paymentService.interceptors.request.use(
  async (requestConfig: AxiosRequestConfig) => {
    try {
      const auth: AuthUser = new AuthUser(await store.dispatch('auth/get'))
      requestConfig.headers.authorization = 'Bearer ' + auth.apiKey
      // tslint:disable-next-line:no-empty
    } catch (e) {}
    return requestConfig
  }
)
Vue.prototype.paymentService = paymentService

const publicApi = axios.create({
  baseURL: config.publicApiUrl,
})
publicApi.interceptors.request.use(
  async (requestConfig: AxiosRequestConfig) => {
    try {
      requestConfig.headers.authorization =
        'Bearer ' + (await firebase.auth().currentUser.getIdToken())
      // tslint:disable-next-line:no-empty
    } catch (e) {}
    return requestConfig
  }
)
Vue.prototype.publicApi = publicApi

const saasService = axios.create({
  baseURL: config.saasServiceBaseUrl,
})
saasService.interceptors.request.use(
  async (requestConfig: AxiosRequestConfig) => {
    try {
      const auth: AuthUser = new AuthUser(await store.dispatch('auth/get'))
      requestConfig.headers.authorization = 'Bearer ' + auth.apiKey
      requestConfig.headers['token-id'] = await firebase
        .auth()
        .currentUser.getIdToken()
      // tslint:disable-next-line:no-empty
    } catch (e) {}
    return requestConfig
  }
)
Vue.prototype.saasService = saasService

const isvService = axios.create({
  baseURL: config.isvServiceBaseUrl,
})
isvService.interceptors.request.use(
  async (requestConfig: AxiosRequestConfig) => {
    try {
      const auth: AuthUser = new AuthUser(await store.dispatch('auth/get'))
      requestConfig.headers.authorization = 'Bearer ' + auth.apiKey
      requestConfig.headers['token-id'] = await firebase
        .auth()
        .currentUser.getIdToken()
      // tslint:disable-next-line:no-empty
    } catch (e) {}
    return requestConfig
  }
)
Vue.prototype.isvService = isvService

const humanRollOverService = axios.create({
  baseURL: config.humanRollOverServiceBaseUrl,
})
humanRollOverService.interceptors.request.use(
  async (requestConfig: AxiosRequestConfig) => {
    try {
      const auth: AuthUser = new AuthUser(await store.dispatch('auth/get'))
      requestConfig.headers.authorization = 'Bearer ' + auth.apiKey
      // tslint:disable-next-line:no-empty
    } catch (e) {}
    return requestConfig
  }
)
Vue.prototype.humanRollOverService = humanRollOverService


const phoneUtil = libphonenumber.PhoneNumberUtil.getInstance()

Validator.extend('phone', {
  getMessage(
    field: string,
    params: { [key: string]: any },
    data: { [key: string]: any }
  ) {
    return (data && data.message) || 'Invalid phone number'
  },
  validate(value: string) {
    if (!value) return true
    try {
      const phoneNumber = phoneUtil.parse(value)
      return phoneUtil.isValidNumber(phoneNumber)
    } catch (error) {
      return false
    }
  },
})

Validator.extend('strongPassword', {
  getMessage: field =>
    'The password must be more than 8 characters including uppercase, lowercase, numbers and special characters.',
  validate: value => {
    var strongRegex = new RegExp(
      '^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*;:"\'{}()_\/\?|~.,<>`-])(?=.{8,})'
    )
    // var strongRegex = new RegExp('^(?=.*[a-zA-Z])')
    return strongRegex.test(value)
  },
})

Validator.extend('uniqueEmail', {
  getMessage: field => 'A user with this email already exists in this agency.',
  validate: async (value, originalValue) => {
    if (originalValue.length > 0 && originalValue[0] === value) return true
    try {
      const auth: AuthUser = new AuthUser(await store.dispatch('auth/get'))
      const response = await axios.post('/exists', {
        email: value,
        companyId: auth.companyId,
      })
      return response.status === 200
    } catch (err) {
      return false
    }
  },
})

const emailRegex =
  /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
Validator.extend('emailOrPhone', {
  getMessage(
    field: string,
    params: { [key: string]: any },
    data: { [key: string]: any }
  ) {
    return (data && data.message) || 'Invalid email address/phone number'
  },
  validate(value: string) {
    if (!value) return true
    try {
      const phoneNumber = phoneUtil.parse(value)
      return phoneUtil.isValidNumber(phoneNumber)
    } catch (error) {
      return emailRegex.test(String(value).toLowerCase())
    }
  },
})

Validator.extend('email', {
  getMessage: () => 'This e-mail address is not valid.',
  validate: email.validate,
})

Validator.extend('twilioPhone', {
  getMessage: () =>
    'You cannot use your inbound number here, it will create a call loop.',
  validate: (phone: never, phone_list: []) => {
    return !phone_list.includes(phone)
  },
})

Validator.extend('twilioPhoneExcludeHosted', {
  getMessage: () =>
    'You cannot use your inbound number here, it will create a call loop.',
  validate: (phone: never, numbers) => {
    if(numbers.phone_numbers.includes(phone)){
      if(!numbers.hosted_numbers[phone]){
        return false
      }else{
        return true
      }
    }
    return true;
  },
})

Vue.use(VeeValidate, {
  classes: true,
  events: 'input|blur',
  fieldsBagName: 'veevalidateFields',
})

Validator.extend('handlebars', {
  getMessage: () =>
    'There are issues in your custom variables, please fix them before saving.',
  validate: (value, useJSSoup = [false]) => {
    const regex =
      /((^{{|[^{\n\r]{{)(?!{))(?!( ?(\w\.?)+ ?(}}(?!}))))|((^{{{|[^{\n\r]{{{)(?!{))(?!( ?(\w\.?)+ ?(}}}(?!}))))|{{4,}|^{(?= )/m

    if (useJSSoup[0]) {
      let soup = new JSSoup(value)
      let body = soup.find('body')
      const testString = body ? body.text : soup.text
      return !regex.test(testString)
    }

    return !regex.test(value)
  },
})

Validator.extend('validUrl', {
  getMessage: () => 'Invalid url.',
  validate: value => {
    const regex =
      /(^\{{2,3})(\w+)(.\w+)?(\}{2,3}$)|(^(http|https):\/\/[^ "]+$)/g
    return regex.test(value)
  },
})

Validator.extend('validUrlToEmpty', {
  getMessage: () => 'Invalid url.',
  validate: value => {
    if(value=='') return true
    const regex =
      /(^\{{2,3})(\w+)(.\w+)?(\}{2,3}$)|(^(http|https):\/\/[^ "]+$)/g
    return regex.test(value)
  },
})

Validator.extend('notEmpty', {
  getMessage: () => 'Field must not be empty.',
  validate: value => {
    return trim(value) !== ''
  },
})



import {Languages, i18n, updateLocale } from './localization'
import { setupSentry } from './plugins/setupSentry'
if (config.mode === 'production'){
  setupSentry(Vue, router, config)
}

new Vue({
  router,
  store,
  i18n,
  render: h => h(PMDApp),
}).$mount('#app')

// Readding loading class on #app
store.commit('setAgencyLoaderState',true)

// var timeout;
// function refresh () {
//   clearTimeout(timeout)
//   timeout = setTimeout(async() => {
//     try {
//       const response = await axios.post('/signout')
//       await store.dispatch('logout')
//     } catch (err) {}
//     router.push({ name: 'login' })
//   }, 20 * 60 * 1000)
// }
// refresh()
// document.addEventListener('click', refresh)
// document.addEventListener('mousemove', refresh)
// document.addEventListener('keydown', refresh)


let locationId
let accountId
let userId
let agencyId

router.beforeEach(async (to, from, next) => {
  // External redirect
  if (to.matched.some((record) => record.meta.RedirectExternalUrl)) {
      let url: string = to.meta.RedirectExternalUrl as string;
      if(to.name == 'university') {
        try {
          const user = new User(await store.dispatch('user/get'))
          url += `&email=${user.email}`
        } catch (err) {}
      }
      window.open(url, '_blank').focus();
      return;
  }
  locationId = to.params.location_id
  const user = new User(await store.dispatch('user/get'))

  await setupLocale(to,from)

  if(locationId && user.type === 'account' && user.locations[locationId] === undefined) {
    console.log(`you are not authorized to access this location: ${locationId}`)
    router.push({name: 'dashboard'})
    return;
  }

  await store.dispatch(
    'auth/refreshFirebaseToken',
    { locationId: to.params.location_id || null, refresh: false },
    { root: true }
  )

  try {
    const currentToken = await firebase.auth().currentUser.getIdToken()
    const decodedPayload = getDecodedJWT(currentToken)
    if(locationId && !decodedPayload?.locations?.includes(locationId)) {
      console.log(`This location: ${locationId} is not accessible. Redirecting to the dashboard page.`)
      router.push({name: 'dashboard'})
      return
    }
  } catch (e) {
    console.error(`Error while decoding token`)
  }

  if (from.name == "conversations-id-v2" && from.name != to.name) {
    await store.dispatch('conversationV2/syncAllV2', {
      locationId: to.params.location_id,
      noListener: true,
      stickyFilterEnabled: store?.getters?.['featureFlags/getForLocation']("conversations.stickyFilters")
    })
  }

  if (from.params.location_id !== to.params.location_id) {
    if (CustomEvent !== undefined) {
      window.dispatchEvent(
        new CustomEvent('locationChangeEvent', {
          detail: {
            from: locationId,
            to: to.params.location_id,
          },
        })
      )
    }


    const element = document.getElementById('app')
    const htmlTag = document.getElementsByTagName('html')[0]
    store.commit('setLocationLoaderState', true)
    htmlTag.className = 'overflow-hidden lead-connector'

    // const assignedTo = user.isAssignedTo ? user.id : ''

    await Promise.all([
      store.dispatch('locations/resetCurrentLocation', {
        locationId: to.params.location_id,
      }),
      store.dispatch('users/syncAll', to.params.location_id),
      // store.dispatch('pipelines/syncAll', to.params.location_id),
      // store.dispatch('campaigns/syncAll', to.params.location_id),
      // store.dispatch('workflows/syncAll', to.params.location_id),
      // store.dispatch('oauth2/syncAll', to.params.location_id),
      // store.dispatch('contacts/syncAll', to.params.location_id),
      store.dispatch('calendars/syncAll', to.params.location_id),
      store.dispatch('userCalendars/syncAll', to.params.location_id),
      store.dispatch('linkedCalendars/syncAll', {
        userId: user.id,
        locationId: to.params.location_id,
      }),
      // store.dispatch('teams/syncAll', to.params.location_id),
      // store.dispatch('conversation/syncAll', {
      //   locationId: to.params.location_id,
      //   assignedTo,
      // }),
      // store.dispatch('mailgunServices/syncAll', to.params.location_id),
      // store.dispatch('membership/syncAll', {
      //   locationId: to.params.location_id,
      // }),
      store.dispatch('locationCustomFields/syncAll', {
        locationId: to.params.location_id,
      }),
      store.dispatch('stripeConnect/syncAll', to.params.location_id),
      store.dispatch('featureFlags/syncAll', to.params.location_id),
      store.dispatch('scoreProfiles/syncAll', to.params.location_id),
    ])
    // store.dispatch('smtpServices/syncAll', to.params.location_id)
    store.dispatch('filters/syncAll', to.params.location_id)
    element.className = ''
    htmlTag.className = ''
    store.commit('setLocationLoaderState', false)

  } else if (accountId !== to.params.account_id) {
    accountId = to.params.account_id
    const element = document.getElementById('app')
    const htmlTag = document.getElementsByTagName('html')[0]
    htmlTag.className = 'overflow-hidden lead-connector'
    await store.dispatch(
      'auth/refreshFirebaseToken',
      { locationId: accountId || null, refresh: false },
      { root: true }
    )
    element.className = ''
    htmlTag.className = ''
  } else {
    // console.log('same location', locationId);
  }

  const sideBarRoute = ['contact_detail']
  const sideBarV2Route = ['contact_detail-v2']
  if (sideBarRoute.includes(to.name)) {
    store.commit('setSideBarState', true)
  } else if (sideBarRoute.includes(from.name)) {
    store.commit('setSideBarState', false)
  }

  if (sideBarV2Route.includes(to.name) || sideBarV2Route.includes(from.name)) {
    store.commit('setSideBarState', false)
  }


  next()

})

var firstLoadCompleted = false

if (config.googleAnalyticId) {
  ga('create', config.googleAnalyticId, 'auto')
  ga('set', 'page', router.currentRoute.name)
  ga('send', 'pageview')
}

// Removing Default App Loader...
router.afterEach(async (to, from) => {
  await setupLocale(to,from)

  if (!firstLoadCompleted) {
    Vue.nextTick(() => {
      // route is now ready.
      const app = document.getElementById('app')
      const htmlTag = document.getElementsByTagName('html')[0]
      if(app && !['login', 'forgot_password'].includes(to.name || '')) app.className = ''
      // htmlTag.className = ''
      store.commit('setAgencyLoaderState', false)
      firstLoadCompleted = true
      // console.log('nextTick');
    })
  }
  if (config.googleAnalyticId) {
    if (to.name !== from.name) {
      ga('set', 'page', to.name)
      ga('send', 'pageview')
    }
  }

  if (CustomEvent !== undefined) {
    window.dispatchEvent(
      new CustomEvent('routeChangeEvent', {
        detail: {
          to: {
            fullPath: to.fullPath,
            name: to.name,
            params: to.params,
            path: to.path,
            query: to.query,
          },
          from: {
            fullPath: from.fullPath,
            name: from.name,
            params: from.params,
            path: from.path,
            query: from.query,
          },
        },
      })
    )
  }
})

export async function setupLocale(to, from) {
  try {
    const userSpecificLanguage = store.state.user?.user?.platformLanguage
    const locationLanguage = store.state.locations?.currentLocation?.locale_settings?.platform
    const languageChosen = (function () {
      if (userSpecificLanguage) return userSpecificLanguage
      if (locationLanguage) return locationLanguage
      return Languages.English_US
    })()

    if (to?.meta?.module !== from?.meta?.module){
      await updateLocale(languageChosen, to.meta.module);
      return true
    } else if (!firstLoadCompleted) {
      // check for better option
      await updateLocale(languageChosen, 'common')
    }

  } catch (error) {
    console.error(error)
  }
}

store.$http = axios
